import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface DunningWorkflowDrawerContextValue {
  selectedWorkflowItemId: string | null;
  openDrawerForWorkflow: (id: string) => void;
  closeDrawer: () => void;
}

const DunningWorkflowDrawerContext = createContext<DunningWorkflowDrawerContextValue | null>(null);

interface ProviderProps {
  children: ReactNode;
}

export function DunningWorkflowDrawerProvider({ children }: ProviderProps) {
  const [selectedWorkflowItemId, setSelectedWorkflowItemId] = useState<string | null>(null);

  const openDrawerForWorkflow = useCallback((id: string) => {
    setSelectedWorkflowItemId(id);
  }, []);

  const closeDrawer = useCallback(() => {
    setSelectedWorkflowItemId(null);
  }, []);

  const value = useMemo(
    () => ({ selectedWorkflowItemId, openDrawerForWorkflow, closeDrawer }),
    [selectedWorkflowItemId, openDrawerForWorkflow, closeDrawer]
  );

  return (
    <DunningWorkflowDrawerContext.Provider value={value}>
      {children}
    </DunningWorkflowDrawerContext.Provider>
  );
}

export function useDunningWorkflowDrawer(): DunningWorkflowDrawerContextValue | null {
  return useContext(DunningWorkflowDrawerContext);
}
